module.exports = __webpack_public_path__ + "img/ZWF_Master_Path.b580321c.jpg";